import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { reportCheckoutReceipt } from '@/lib/checkoutReceipt';
import { checkoutReceiptReturn } from '@/lib/checkoutReceiptRoute';

/** Reporting survives a legacy route redirect or delayed auth; it never controls access. */
export default function CheckoutReceiptObserver(): null {
  const { pathname, search } = useLocation();
  const { user, loading } = useAuth();
  const current = checkoutReceiptReturn(pathname, search);
  const pending = useRef<ReturnType<typeof checkoutReceiptReturn>>(null);
  if (current) pending.current = current;
  useEffect(() => {
    if (loading || !user || !pending.current) return;
    const receipt = pending.current;
    pending.current = null;
    void reportCheckoutReceipt(receipt.sessionId, receipt.surface, user.id);
  }, [loading, user?.id, current?.sessionId, current?.surface]);
  return null;
}
